import gql from 'graphql-tag';

export const GET_CONTACT_MESSAGE_LIST_BY_RESERVE_NO = gql`
    query(
        $golf_group_code: String!
        $golf_code: String!
        $reserve_no: String!
    ){
        getContactsMessageListByReserveNo(
            golf_group_code: $golf_group_code
            golf_code: $golf_code
            reserve_no: $reserve_no
        ){
            Message{
                id
                send_id
                message
                completed
                created_at
            }
        }
    }
`;
export const GET_CONTACT_MESSAGE_LIST = gql`
    query(
        $golf_group_code: String!
        $golf_code: String!
        $member_no: String!
        $reserve_no: String!
    ){
        getContactsMessageList(
            golf_group_code: $golf_group_code
            golf_code: $golf_code
            member_no: $member_no
            reserve_no: $reserve_no
        ){
            Message{
                id
                send_id
                message
                completed
                created_at
            }
        }
    }
`;

export const GET_CONTACT_MESSAGE_LIST_WEB_MEMBER_NO = gql`
    query(
        $golf_group_code: String!
        $member_no: String!
        $reserve_no: String!
    ){
        getContactsMessageListWebMemberNo(
            golf_group_code: $golf_group_code
            member_no: $member_no
            reserve_no: $reserve_no
        ){
            Message{
                id
                send_id
                message
                completed
                created_at
            }
            golfList{
                golf_code
                golf_name
            }
        }
    }
`;

export const POST_MESSAGE = gql`
    mutation(
        $golf_group_code: String!
        $golf_code: String!
        $member_no:Int!
        $reserve_no: String!
        $send_id: Int
        $message: String
        $completed: Int!
        ){
        postMessage(
            golf_group_code: $golf_group_code
            golf_code: $golf_code
            member_no: $member_no
            reserve_no: $reserve_no
            send_id: $send_id
            message: $message
            completed: $completed
        ){
            result
        }
    }
`;
export const GET_MESSAGE_INFO = gql`
    query(
        $member_no: Int!
        ){
        getMessageInfo(
            member_no: $member_no
        ){
            time
            reserve_no
            play_date
        }
    }
`;

export const SEND_INQUIRY_NOTICE_EMAIL = gql`
    mutation(
        $reserve_no: String
        $golf_group_code: String
        $golf_code: String
        $member_no: String
        $family_name: String
        $given_name: String
        ){
            VerifyNoticeInquiryEmail(
                reserve_no: $reserve_no
                golf_group_code: $golf_group_code
                golf_code: $golf_code
                member_no: $member_no
                family_name: $family_name
                given_name: $given_name
        ){
            result
        }
    }
`;

export const REGIST_MESSAGE = gql`
    mutation (
        $golf_group_code: String!
        $golf_code: String!
        $member_no: String!
        $reserve_no: String!
        $send_id: Int
        $message: String
        $completed: Int
        $family_name: String
        $given_name: String
    ){
        RegistMessage(
            golf_group_code: $golf_group_code
            golf_code: $golf_code
            member_no: $member_no
            reserve_no: $reserve_no
            send_id: $send_id
            message: $message
            completed: $completed
            family_name: $family_name
            given_name: $given_name
        ){
            Message{
                id
                send_id
                message
                completed
                created_at
            }
            result
        }
    }
`;
